import { CHANGE_HOTEL_INFO_STATE, HotelInfoActionTypes, HotelInfoState } from "store/reducers/hotelInfo/types";

const defaultState: HotelInfoState = {
  isOpen: true
};

export default function hotelInfo(state = defaultState, action: HotelInfoActionTypes): HotelInfoState {
  switch (action.type) {
    case CHANGE_HOTEL_INFO_STATE:
      return {
        isOpen: action.isOpen
      };
    default:
      return state;
  }
}